import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../app/axiosBaseQuery';

export const plansApi = createApi({
  reducerPath: 'plansApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Plan', 'AdminPlan'],
  endpoints: (builder) => ({
    // Public catalogue — active plans only, shown to investors.
    listPlans: builder.query({
      query: () => ({ url: '/plans', method: 'GET' }),
      providesTags: ['Plan'],
    }),
    adminListPlans: builder.query({
      query: () => ({ url: '/admin/plans', method: 'GET' }),
      providesTags: ['AdminPlan'],
    }),
    createPlan: builder.mutation({
      query: (body) => ({ url: '/admin/plans', method: 'POST', data: body }),
      invalidatesTags: ['AdminPlan', 'Plan'],
    }),
    updatePlan: builder.mutation({
      query: ({ id, ...body }) => ({ url: `/admin/plans/${id}`, method: 'PUT', data: body }),
      invalidatesTags: ['AdminPlan', 'Plan'],
    }),
    archivePlan: builder.mutation({
      query: (id) => ({ url: `/admin/plans/${id}/archive`, method: 'PATCH' }),
      invalidatesTags: ['AdminPlan', 'Plan'],
    }),
    activatePlan: builder.mutation({
      query: (id) => ({ url: `/admin/plans/${id}/activate`, method: 'PATCH' }),
      invalidatesTags: ['AdminPlan', 'Plan'],
    }),
  }),
});

export const {
  useListPlansQuery,
  useAdminListPlansQuery,
  useCreatePlanMutation,
  useUpdatePlanMutation,
  useArchivePlanMutation,
  useActivatePlanMutation,
} = plansApi;
